const tooltipActionExpPanel = {
  title: 'Gerar Nova Ação'
};

export default tooltipActionExpPanel;
